import {
  queryAccount,
  addAccount,
  updateAccount,
} from '@/api/modules/account.js';
import { setLocalStorage } from '@/utils/localStorage';
import Address from '@/utils/address';
import { ERROR_CODE } from '@/const/base.js';

const state = {
  accountInfo: {
    baseInfo: {},
    businessInfo: {},
  },
  accountInfoLoading: true,
  isHasAccount: false,
};

const getters = {
  businessInfo(state) {
    const { businessInfo = {}, baseInfo = {} } = state.accountInfo;
    return { ...businessInfo, ...baseInfo };
  },
  accountInfo(state) {
    return state.accountInfo;
  },
  uid(state) {
    return state.accountInfo?.baseInfo?.uid;
  },
  phone(state) {
    return state.accountInfo?.baseInfo?.phone;
  },
};

const mutations = {
  updateAccountInfo(state, data = {}) {
    state.isHasAccount = true;
    const { businessInfo = {}, baseInfo = {} } = data;
    state.accountInfo = { baseInfo, businessInfo };
    // 更新poi信息
    if (businessInfo?.address?.cityId) {
      Address.setAddress(businessInfo.address);
    }
  },
  updateAccountInfoLoading(state, data) {
    state.accountInfoLoading = data;
  },
};

const actions = {
  async updateAccount({ dispatch }, params) {
    const res = await updateAccount(params);
    if (!res) return false;
    await dispatch('getAccountInfo');
    return res;
  },
  async addAccount({ dispatch }, params) {
    const res = await addAccount(params);
    if (!res) return false;
    await dispatch('getAccountInfo');
    return res;
  },
  async getAccountInfo({ commit }, params) {
    const data = await queryAccount(params);
    commit('updateAccountInfoLoading', false);
    // 未登录返回 false
    if (data?.errno === ERROR_CODE.NOT_LOGIN) {
      commit('updateAccountInfo', {});
      return false;
    }
    data && commit('updateAccountInfo', data);
    const uid = data?.baseInfo?.uid;
    uid && setLocalStorage('uid', uid);
    return data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
